import { render } from "./DropdownProfile.vue?vue&type=template&id=6323b600"
import script from "./DropdownProfile.vue?vue&type=script&lang=js"
export * from "./DropdownProfile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__